var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2014_1391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08337 0.832031L11.8334 3.58203M11.8334 3.58203L9.08337 6.33203M11.8334 3.58203H5.23337C3.69323 3.58203 2.92315 3.58203 2.3349 3.88176C1.81745 4.14541 1.39676 4.56611 1.13311 5.08356C0.833374 5.67181 0.833374 6.44188 0.833374 7.98203V13.207C0.833374 13.6327 0.833374 13.8456 0.856905 14.0243C1.01937 15.2583 1.99041 16.2294 3.22443 16.3918C3.40313 16.4154 3.61599 16.4154 4.04171 16.4154M8.16671 16.4154H14.7667C16.3069 16.4154 17.0769 16.4154 17.6652 16.1156C18.1827 15.852 18.6033 15.4313 18.867 14.9139C19.1667 14.3255 19.1667 13.5555 19.1667 12.0154V6.79036C19.1667 6.36465 19.1667 6.15179 19.1431 5.97308C18.9807 4.73907 18.0097 3.76802 16.7757 3.60556C16.5969 3.58203 16.3841 3.58203 15.9584 3.58203M8.16671 16.4154L10.9167 19.1654M8.16671 16.4154L10.9167 13.6654",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2014_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.88a37466.svg";
export { ForwardRef as ReactComponent };